import * as React from 'react';
import { useIntl } from 'react-intl';

import { AH$RouterLocation } from 'types';
import thematize from 'lib/thematize';
import { NavigateFunction } from 'hooks/useNavigate';
import messages from 'components/AdminPanel/Companies/messages';
import Button from 'components/Base/Button';
import Dropdown from 'components/Base/Dropdown';
import styles from './Actions.scss';

const theme = thematize(styles);

interface Props {
  location: AH$RouterLocation;
  navigate: NavigateFunction;
}

const Actions = ({ location, navigate }: Props): React.ReactElement => {
  const { formatMessage } = useIntl();

  const handleAddCompanyClick = (): void => {
    navigate({
      pathname: '/companies/new/',
    });
  };

  return (
    <div className={theme('wrapper')}>
      <div className={theme('container')}>
        <Dropdown
          bodyClassName={theme('export-body')}
          button={
            <Button color="default" appearance="text" className={theme('export-button')}>
              {formatMessage(messages.export)}
            </Button>
          }
        >
          <a href={`/api/internal/companies/export/${location.search}`} aria-label="menuitem">
            <Dropdown.Option
              optionClassName={theme('export-option')}
              textValue={formatMessage(messages.exportCompanies)}
            />
          </a>
          <a href={`/api/internal/employees/export/${location.search}`} aria-label="menuitem">
            <Dropdown.Option
              optionClassName={theme('export-option')}
              textValue={formatMessage(messages.exportClients)}
            />
          </a>
        </Dropdown>
        <Button color="primary" appearance="text" onClick={handleAddCompanyClick}>
          {formatMessage(messages.addCompany)}
        </Button>
      </div>
    </div>
  );
};

export default Actions;
